<template>
  <v-card 
    flat 
    class="h-100" 
    :loading="loading"
  >
    <v-card-text class="text-center">
      <span class="text-h6">
        Thông tin khác
      </span>
    </v-card-text>
    <v-card-text>
      <v-row>
        <!-- Desktop -->
        <!-- <v-col v-if="!isMobile">
          <v-card
            v-for="(relatedItem, index) in items" 
            :to="{ name: 'NewsView', params: { id: relatedItem.id }}"
            :key="index"
            class="px-6"
            flat
          >
            <div class="d-flex flex-no-wrap">
              <v-avatar
                class="ma-3 rounded-lg"
                size="100"
                tile
              >
                <v-img :src="`${apiBaseUrl}/uploads/${relatedItem.anh_dai_dien}`"/>
              </v-avatar>
              <div>
                <v-card-title class="text-h6">
                  {{relatedItem.tieu_de}}
                </v-card-title>
                <v-card-subtitle>
                  <v-icon small>mdi-clock</v-icon>
                  <span class="font-italic ml-1">{{relatedItem.published_at}}</span>
                </v-card-subtitle>
              </div>
            </div>
          </v-card>
        </v-col> -->
        <!-- Mobile -->
        <v-col
          cols="12"
          v-for="(relatedItem) in items" 
          :key="relatedItem.id"
        >
          <v-sheet class="rounded-lg overflow-hidden h-100 mb-4">
            <v-card flat>
              <router-link
                :to="{ name: 'NewsView', params: { id: relatedItem.id }}"
              >
                <v-img
                  v-if="relatedItem.anh_dai_dien"
                  :src="`${apiBaseUrl}/uploads/${relatedItem.anh_dai_dien}`"
                  :aspect-ratio="16/9"
                />
                <v-img
                  v-else
                  src="@/assets/NoImage.jpg"
                  :aspect-ratio="16/9"
                />
              </router-link>
              <v-card-subtitle class="py-2">
                <span class="caption font-italic mr-4">
                  <v-icon small>mdi-clock</v-icon>
                  {{relatedItem.published_at}}, {{relatedItem.custom_created_at}}
                </span>
                <span class="caption font-italic">
                  <v-icon small>mdi-eye</v-icon>
                  {{ relatedItem.countview || 1 }}
                </span>
              </v-card-subtitle>
              <v-card-title class="py-0">
                <div class="text-body-1 font-weight-medium news-title">
                  <router-link
                    :to="{ name: 'NewsView', params: { id: relatedItem.id }}"
                    class="black--text"
                    :title="relatedItem.tieu_de"
                  >
                    {{relatedItem.tieu_de}}
                  </router-link>
                </div>
              </v-card-title>
              <v-card-actions>
                <v-btn
                  v-if="relatedItem.muc_do != null && relatedItem.muc_do != 'NORMAL'"
                  dark
                  :color="relatedItem.muc_do=='DANGER' ? 'red' : 'orange'"
                  class="news-level"
                  fab
                  small
                >
                  <v-icon>mdi-alert{{relatedItem.muc_do=='DANGER' ? '-octagon' : ''}}</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props:{
    currentId:{
      type: String
    }
  },
  data: () => ({
    loading: false,
    items: []
  }),
  computed: {
    ...mapState([
      'config'
    ]),
    apiBaseUrl() {
      return this.config.beUrl;
    },
    isMobile(){
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    currentId: function() {
      this.getRelatedItems();
    }
  },
  mounted() {
    if(this.currentId){
      this.getRelatedItems();
    }
  },
  methods: {
    getRelatedItems(){
      const app = this;
      app.loading = true;
      axios.get(`api/v1/public/news-related/${this.currentId}`)
        .then(response => {
          app.items = response.data;
          app.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          app.loading = false;
        });
    },
  }
}
</script>